import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("li", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("li", null, null, -1)

import getUser from '../composables/getUser'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { user } = getUser()

return (_ctx: any,_cache: any) => {
  return (_unref(user))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", null, "Página de " + _toDisplayString(`${_unref(user).displayName} (${_unref(user).email})`), 1),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, "uid: " + _toDisplayString(_unref(user).uid), 1),
          _createElementVNode("li", null, "Usuário criado em " + _toDisplayString(_unref(user).metadata.creationTime), 1),
          _createElementVNode("li", null, "Último login em " + _toDisplayString(_unref(user).metadata.lastSignInTime), 1),
          _createElementVNode("li", null, _toDisplayString(_unref(user).tenantId), 1),
          _createElementVNode("li", null, _toDisplayString(_unref(user).getIdToken), 1),
          _createElementVNode("li", null, "Id fornecido " + _toDisplayString(_unref(user).providerId), 1),
          _hoisted_2,
          _hoisted_3
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})